<script setup lang="ts">
defineOptions({
  name: 'CyclabilityOverviewSarajevo',
})

const { t } = useI18n()

// prepare data for the city from CSV
const cityData = useCyclabilityCitiesData({
  compareWith: 'lastYear',
  rangeLimit: 60,
}) as ReturnType<typeof useCyclabilityCitiesData>
const cityDataCounter = useCyclabilityCitiesData({
  subfix: 'counter',
  compareWith: 'lastYear',
  rangeLimit: 60,
}) as ReturnType<typeof useCyclabilityCitiesData>

provide('cityData', cityData)
provide('cityDataCounter', cityDataCounter)
</script>

<template>
  <BoardSubTitle icon="list">
    {{ t('cyclability.bike_usage') }}
  </BoardSubTitle>

  <BoardGrid class="mt-4 grid-cols-1 lg:grid-cols-6">
    <CityCyclabilityPassagesMetric class="lg:col-span-3 2xl:col-span-4" />
    <CityCyclabilityBikesPerformance class="lg:col-span-3 2xl:col-span-2" />
    <CityCyclabilityPassagesHistoryMetric
      show-all-data
      class="lg:col-span-6"
    />
    <CityCyclabilitySharedBikesPerfMetric
      show-all-data
      class="lg:col-span-6"
    />
  </BoardGrid>

  <BoardSubTitle icon="list">
    {{ t('cyclability.additional_informations') }}
  </BoardSubTitle>

  <BoardGrid class="mt-4 grid-cols-1 lg:grid-cols-6">
    <CityCyclabilitySarajevoCyclistAnalysisMetric class="lg:col-span-3" />
    <CityCyclabilitySarajevoNetworkOverview class="lg:col-span-3" />
  </BoardGrid>
</template>
